var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMsn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.616 23.945c-1.397 0-2.588-.877-2.588-2.865 0-3.068 2.64-5.398 3.838-6.057 0 0 1.677.965 3.416 1.587-3.456-2.186-5.664-6.17-5.664-10.59C4.618 1.888 6.8.028 8.768.028c1.584 0 5.34 1.742 5.34 8.428 0 7.195-3.755 15.49-8.492 15.49z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.654 21.665c0 1.043.364 1.451.921 1.451 1.394 0 3.614-3.252 3.53-6.667 2.113-2.23 4.646-5.722 4.646-8.519 0-.677-.192-1.247-.995-1.247-1.227 0-2.98 2.115-4.092 4.215-1.072 2.175-2.075 4.656-3.407 8.061-.311.854-.603 1.889-.603 2.706z"
  })));
}

export default SvgMsn;